export enum Language {
  English = 'en',
  Russian = 'ru',
  Kazakh = 'kz',
}

export enum UserRole {
  Admin = 'admin',    // Owner / Head of Department
  Manager = 'manager',
  Doctor = 'doctor',
  Patient = 'patient',
  Auditor = 'auditor',
}

export enum AuditStatus {
  NotSubmitted = 'not_submitted',
  PendingAudit = 'pending_audit',
  Approved     = 'approved',
  Revision     = 'revision_requested',
}

export enum ConsultationStatus {
  Active = 'active',
  Completed = 'completed',
}

export enum ReviewStatus {
  Draft = 'draft',
  Complete = 'complete',
}

export enum Gender {
  Male = 'male',
  Female = 'female',
}

export enum DepartmentPosition {
  HeadDoctor = 'head_doctor',
  DepartmentHead = 'department_head',
  Expert = 'expert',
  GeneralDoctor = 'general_doctor',
}

export enum EpisodeStage {
  PrimaryExamination = 'primary_examination',
  Investigation = 'investigation',
  Strategy = 'strategy',
  Monitoring = 'monitoring',
  Resolution = 'resolution',
}
